import type { Address, Card, Position } from "../data/types";

export const POOL_ROWS = 7;
export const POOL_COLS = 5;
export const WINDOW_ROWS = 2;
export const WINDOW_COLS = 3;

export const SELECTION_ROWS = 6;
export const SELECTION_COLS = 3;

export const ADDRESS_SELECTION_ROW_OFFSET: Record<Address, number> = {
  A: 0,
  B: 2,
  C: 4,
};

export function poolIndex(row: number, col: number): number {
  return row * POOL_COLS + col;
}

export function isTopHalf(position: Position): boolean {
  return position <= 3;
}

export function colAnchorForPosition(position: Position): number {
  return (position - 1) % WINDOW_COLS;
}

export function rowAnchorForPosition(position: Position): number {
  return isTopHalf(position) ? 0 : 1;
}

export function positionToCustomCell(position: Position): {
  row: number;
  col: number;
} {
  return {
    row: isTopHalf(position) ? 0 : 1,
    col: (position - 1) % WINDOW_COLS,
  };
}

export function getSelectionPool(position: Position): {
  rows: number[];
  cols: number[];
} {
  const rowStart = rowAnchorForPosition(position);
  const colStart = colAnchorForPosition(position);
  return {
    rows: Array.from({ length: SELECTION_ROWS }, (_, i) => rowStart + i),
    cols: Array.from({ length: SELECTION_COLS }, (_, i) => colStart + i),
  };
}

export function getWindow(
  position: Position,
  address: Address,
): { rows: number[]; cols: number[] } {
  const selection = getSelectionPool(position);
  const offset = ADDRESS_SELECTION_ROW_OFFSET[address];
  return {
    rows: selection.rows.slice(offset, offset + WINDOW_ROWS),
    cols: selection.cols,
  };
}

export function getCustomScreenCards(
  cards: readonly Card[],
  position: Position,
  address: Address,
): { card: Card; poolRow: number; poolCol: number }[] {
  const { rows, cols } = getWindow(position, address);
  const out: { card: Card; poolRow: number; poolCol: number }[] = [];
  for (const r of rows) {
    for (const c of cols) {
      out.push({
        card: cards[poolIndex(r, c)],
        poolRow: r,
        poolCol: c,
      });
    }
  }
  return out;
}
